<template>
  <v-tooltip small top :fixed="true" :color="color" nudge-bottom="40">
    <template v-slot:activator="{ on }">
      <v-chip
        :color="color"
        class="ml-0 mr-2 font-weight-bold white--text"        
        small
        v-on="on"
        >{{ text.substring(0, 1).toUpperCase()
        }}{{ text.substring(1, 3) }}...</v-chip
      >
    </template>
    <v-chip
      :color="color"
      class="ml-0 mr-2 font-weight-bold white--text"
      small
      >{{ text }}</v-chip
    >
  </v-tooltip>
</template>

<script>
export default {
  props: {
    status: String,
  },

  data() {
    return {
      statusList: {
        open: {
          color: "cyan",
          text: "Open",
        },
        inprogress: {
          color: "warning",
          text: "In Progress",
        },
        canceled: {
          color: "error",
          text: "Canceled",
        },
        completed: {
          color: "info",
          text: "Completed",
        },
        invoiced: {
          color: "primary",
          text: "Invoiced",
        },
        complete: {
          // this is need to be deleted later
          color: "info",
          text: "Completed",
        },
        closed: {
          // this is need to be deleted later
          color: "info",
          text: "Completed",
        },
      },
    };
  },
  computed: {
    colorize() {
      if (this.statusList[this.status]) {
        return this.statusList[this.status];
      }
      return {
        color: "secondary",
        text: this.status ? this.status : "Not set",
      };
    },
    color() {
      return this.colorize.color;
    },
    text() {
      return this.colorize.text;
    },
  },
};
</script>